import { useTranslation } from "@/src/i18n/client";
import { useCommonContext } from "@/src/provider";
import { getSiteConfiguration } from "@/src/utils/configUtils";
import React from "react";

interface Props {}

const WarrantyTime: React.FC<Props> = () => {
    const { host, site } = useCommonContext();
    const { t } = useTranslation("common");

    const footerServiceWarranty = getSiteConfiguration(
        "footerServiceWarranty",
        host,
    );

    switch (site) {
        case "uk":
        case "us":
            return t("common:advantage.title2_6");
        default:
            return t(footerServiceWarranty.title);
    }
};

export default WarrantyTime;
